import type { ProductionOrderSheetLine } from '@repo/api-contracts';

/** 발주서 합계 — 단가가 있는 행의 수량 × 단가 합. 단가가 있는 행이 하나도 없으면 null. */
export const productionOrderSheetTotal = (
  lines: readonly ProductionOrderSheetLine[],
): number | null => {
  const priced = lines.filter((line) => line.unitPrice !== null);
  if (priced.length === 0) return null;
  return priced.reduce((sum, line) => sum + line.quantity * (line.unitPrice ?? 0), 0);
};
